import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import useFloatingMenuVisibility from './useFloatingMenuVisibility';

const FloatingMenu = ({ floatingButtons, onClick = () => { } }) => {
  const { visibleButtons, visibleCountOnScreen, showMoreMenu } = useFloatingMenuVisibility(floatingButtons);

  return (
    <div className="floating-menu-in w-75">
      {
        visibleButtons.map((value, index) => {
          const isLastVisibleButton = !showMoreMenu && index === visibleCountOnScreen - 1;
          return (
            <OverlayTrigger
              key={`float-top-${value.id}`}
              placement='top'
              overlay={
                <Tooltip id={`tooltip-top-${value.id}`} className='custom-tooltip'>
                  {value.tooltip}
                </Tooltip>
              }>
              <button type="button" className={`${value.isEnabled ? 'text-castleRed' : ''} ${isLastVisibleButton ? 'floating-menu-last-visible' : ''}`.trim()} id={`floating-menu-${value.id}`} disabled={value.disabled} onClick={() => onClick(value.id)}>
                {value.icon}
                {value.name}
              </button>
            </OverlayTrigger>
          );
        })
      }

      {showMoreMenu &&
        <Dropdown>
          <Dropdown.Toggle className='floating-menu-last-visible'>
            <FontAwesomeIcon icon={faEllipsis} />More</Dropdown.Toggle>
          <Dropdown.Menu>
            {visibleButtons.map((value, index) => (
              <Dropdown.Item key={`float-menu-${index}`} disabled={value.disabled} onClick={() => onClick(value.id)}>
                {value.icon} {value.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      }
    </div>
  );
};

FloatingMenu.propTypes = {
  floatingButtons: PropTypes.array.isRequired,
  onClick: PropTypes.func
};

FloatingMenu.defaultProps = {
  floatingButtons: []
};

export default FloatingMenu;
